import React, { useEffect, useState } from 'react';
import { CheckCircle } from 'lucide-react';
const RECENT_SALES = [{
  name: 'María',
  country: 'México'
}, {
  name: 'Juan',
  country: 'Colombia'
}, {
  name: 'Ana',
  country: 'España'
}, {
  name: 'Carlos',
  country: 'Argentina'
}, {
  name: 'Sofía',
  country: 'Chile'
}, {
  name: 'Laura',
  country: 'Perú'
}, {
  name: 'Diego',
  country: 'Estados Unidos'
}, {
  name: 'Valentina',
  country: 'México'
}];
export function SalesPopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [currentSale, setCurrentSale] = useState(RECENT_SALES[0]);
  useEffect(() => {
    // Initial delay
    const initialTimeout = setTimeout(() => {
      setIsVisible(true);
    }, 5000);
    // Cycle through sales
    const cycleInterval = setInterval(() => {
      setIsVisible(false);
      setTimeout(() => {
        const randomIndex = Math.floor(Math.random() * RECENT_SALES.length);
        setCurrentSale(RECENT_SALES[randomIndex]);
        setIsVisible(true);
      }, 2000); // Wait 2s before showing next one
    }, 15000); // Show every 15 seconds
    return () => {
      clearTimeout(initialTimeout);
      clearInterval(cycleInterval);
    };
  }, []);
  if (!isVisible) return null;
  return <div className="fixed bottom-4 left-4 z-50 animate-fade-in-up" data-id="element-1">
      <div className="bg-white rounded-lg shadow-lg p-4 flex items-center gap-4 border-l-4 border-green-500 max-w-xs" data-id="element-2">
        <div className="bg-green-100 p-2 rounded-full flex-shrink-0" data-id="element-3">
          <CheckCircle className="w-6 h-6 text-green-600" data-id="element-4" />
        </div>
        <div data-id="element-5">
          <p className="text-sm font-bold text-gray-800" data-id="element-6">
            {currentSale.name} de {currentSale.country}
          </p>
          <p className="text-xs text-gray-600" data-id="element-7">
            compró el Megapack hace unos instantes
          </p>
        </div>
      </div>
    </div>;
}